import React from 'react';
import {
  PageWrapper, PageHeader, PageTitleGroup, PageTitle, PageSubtitle,
  EmptyState, EmptyStateTitle, EmptyStateCode,
  PrivacyNotice, PrivacyNoticeIcon
} from './MyMeetingsPage.styles';

/**
 * Preview / "coming soon" screen shown at /live-meetings when the company does
 * not have the Live Meetings feature enabled (company.liveMeetingsEnabled).
 * Keeps the same data-tour anchor as the real page so the tutorial still lands.
 */
const LiveMeetingsComingSoon = () => (
  <PageWrapper data-tour="my-meetings-page">
    <PageHeader>
      <PageTitleGroup>
        <PageTitle>Live Meetings</PageTitle>
        <PageSubtitle>Coming soon for your team</PageSubtitle>
      </PageTitleGroup>
    </PageHeader>

    <EmptyState>
      <EmptyStateTitle>🎥 Murphy can sit in on your real sales calls</EmptyStateTitle>
      <p>
        Multiply doesn't just grade practice pitches — Murphy can join your live
        customer meetings too. When enabled for your team, you will have access to add Murphy to calendar
        invites just like any other meeting participant. Murphy will join the meeting, 
        listen to your team and prospects, and email you a recap with grading-style coaching once the meeting is done.
      </p>
      <p style={{ marginTop: '20px', fontWeight: 600 }}>
        Live Meetings isn't enabled for your company yet. Ask your Multiply
        advisor for a demo and how your team can get Murphy into your sales meetings!
      </p>
    </EmptyState>

    <PrivacyNotice style={{ marginTop: 20 }}>
      <PrivacyNoticeIcon aria-hidden="true">{'ℹ️'}</PrivacyNoticeIcon>
      <span>
        <strong>A note on privacy.</strong> Your data is secure. Murphy never stores your recordings and never uses your conversations to train models. Even so, only invite him to sales calls: prospecting, discovery, demos. If a meeting turns to PII, HR, finance, or anything confidential, just remove <code>murphy@askmultiply.com</code> from the participants and he'll drop off automatically.
      </span>
    </PrivacyNotice>
  </PageWrapper>
);

export default LiveMeetingsComingSoon;
